<template>
    <div>
        <div class="items">
            <div class="item card-white"> <!-- :class="{ 'margin-200-top': status.complete } -->

                <div class="card margin-card" v-if="!status.complete">
                  <eyebrow-icon v-if="true" v-bind:eyebrowicon="{'icon':'star-outline', 'color':'black'}" v-bind:align="'center'"></eyebrow-icon>
                  <h4>Share your feedback on {{ this.acf.model }}</h4>
                </div>

                <form id="ContactForm" ref="contact_form" class="contact-form" action="javascript:" v-on:submit.prevent="submit">

                    <div v-if="!status.complete">

                        <div class="group">
                          <label for="notPurchasedReason">Why haven’t you purchased or tried this mask?</label>
                          <select class="validation selectOptGroup"
                                  id="notPurchasedReason"
                                  v-bind:class="{ '-invalid': validation.notPurchasedReason }"
                                  v-model="fields.notPurchasedReason"
                                  @change="updateView">
                              <option selected disabled value="">Select from the following options...</option>
                              <option data-journeyphase="1" value="I have not been diagnosed with sleep apnea"> I have not been diagnosed with sleep apnea</option>
                              <option data-journeyphase="2" value="I have a prescription for CPAP equipment, but don't know what to do next">I have a prescription for CPAP equipment, but don't know what to do next</option>
                              <option data-nextstep="[1]" value="I use a different CPAP mask">I use a different CPAP mask </option>
                              <option data-nextstep="[4]" value="I've tried this mask, and did not like it">I've tried this mask, and did not like it</option>
                              <option data-nextstep="[1]" value="I'd like to try it but would need to switch from another CPAP mask">I'd like to try it but would need to switch from another CPAP mask</option>
                              <option data-journeyphase="3" value="Haven't selected a CPAP mask; still deciding">Haven't selected a CPAP mask; still deciding</option>
                              <option data-nextstep="[3]" value="Other">Other</option>
                          </select>
                          <div class="error-message" v-for="message in validation.notPurchasedReason">{{ message }}</div>
                        </div>
 
                        <div v-show="status.step.indexOf(1) != -1" class="group">
                           <label for="otherMaskBrand">What mask brand are you currently using?</label>
                           <select class="validation selectOptGroup"
                                     v-bind:class="{ '-invalid': validation.otherMaskBrand }"
                                     v-model="fields.otherMaskBrand"
                                     @change="updateOtherMaskBrand">
                               <option selected disabled value="">Select from the following options...</option>
                               <option data-nextstep="[1,2]" value="ResMed">ResMed</option>
                               <option data-nextstep="[1,2]" value="Fisher & Paykel">Fisher & Paykel</option>
                               <option data-nextstep="[1,2]" value="Philips Respironics">Philips Respironics</option>
                               <option data-nextstep="[1,2]" value="Other">Other</option>
                           </select>
                           <div class="error-message" v-for="message in validation.otherMaskBrand">{{ message }}</div>
                           
                        </div>

                        <div v-show="status.step.indexOf(2) != -1 && fields.otherMaskBrand == 'Other'" class="group">
                           <label for="maskModel">Write your current mask model</label>
                           <input type="text" class="validation"
                                  v-bind:class="{ '-invalid': validation.otherMaskModels }"
                                  v-model="fields.otherMaskModels">
                           <div class="error-message" v-for="message in validation.otherMaskModels">{{ message }}</div>
                        </div>



                   <!-- <div v-else-if="status.step.indexOf(2) != -1" class="group"> -->
                        <div v-show="status.step.indexOf(2) != -1 && fields.otherMaskBrand != 'Other'" class="group">
                           <label for="maskModel">Pick your current mask model</label>
                           <select class="validation selectOptGroupBrand"
                                     v-bind:class="{ '-invalid': validation.otherMaskModels }"
                                     v-model="fields.otherMaskModels"
                                     @change="updateView">
                               <option selected disabled value="">Select from the following options...</option>
                               <option data-nextstep="[1,2]" v-for="element in masks[fields.otherMaskBrand]" v-bind:value="element" >{{ element }}</option>
                           </select>
                           <div class="error-message" v-for="message in validation.otherMaskModels">{{ message }}</div>
                        </div>

                        <div v-show="status.step.indexOf(3) != -1" class="group">
                           <label for="dislikeReason">Other reason</label>
                           <textarea class="validation"
                                     v-bind:class="{ '-invalid': validation.dislikeReason }"
                                     v-model="fields.dislikeReason"
                                     v-on:keyup="validation.dislikeReason = null"
                                     placeholder="Please provide feedback on this product here (max 280 characters)" maxlength="280"></textarea>
                           <div class="error-message" v-for="message in validation.dislikeReason">{{ message }}</div>
                        </div> 

                        <div v-show="status.step.indexOf(4) != -1" class="group">
                           <label for="dislikeReview">What didn't you like about this mask?</label>
                           <textarea class="validation"
                                     v-bind:class="{ '-invalid': validation.dislikeReview }"
                                     v-model="fields.dislikeReview"
                                     v-on:keyup="validation.dislikeReview = null"
                                     placeholder="Please write what you didn't like about this product here (max 200 characters)" maxlength="200"></textarea>
                           <div class="error-message" v-for="message in validation.dislikeReview">{{ message }}</div>
                        </div>


                        <!-- firstname -->
                        <firstname></firstname>

                        <!-- lastname -->
                        <lastname></lastname>

                        <!-- email and phone -->
                       <email></email>

                        <!-- select: country -->
                        <country></country>

                        <!-- checkbox: feedbackConcent -->
                        <feedbackConsent></feedbackConsent>

                        <!-- checkbox: marketing_oncent -->
                        <marketingConsent></marketingConsent>

                        <!-- submit, validation and confirmation -->
                        <submit-confirmation></submit-confirmation>

                    </div>
                </form>
                <thankyou-message v-if="status.complete"></thankyou-message>
            </div>
        </div>
    </div>

</template>

<script>

    import mixin from './mixin'

    let fillable = {
        notPurchasedReason: '',
        dislikeReason: '', 
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        feedbackConsent: '',
        marketing_consent: true,
        referrer: window.location.pathname,
        b2c: 'yes',
        b2b: 'no',
        yes_Rating: false,
        no_Rating: true,
        maskBrand: '',
        otherMaskBrand: '',
        maskModel: '',
        otherMaskModels: '',
        timeOnMachineDatestamp : '',
        consumerJourneyPhase: '',
        consumerJourneyPhaseDetail: '',
        dislikeReview: '',
        reviewDescription: '',
        marketingConsentDate: (new Date()).toISOString(),
    }

    export default {
        data() {
            return {
                form: {
                    name: '',   // form name
                    origin: ''  // form origin ( page )
                },
                status: {
                    idle: null,
                    step: [],
                    last_step: [],
                    errors: false,
                    complete: false,
                },
                response: {
                    type: '', // validation or confirmation
                    message: '' // response
                },
                holdingValue: {},
                fields: { ...fillable },
                validation: {},
                masks:{
                  'ResMed': [
                    'AirTouch F20',
                    'AirFit F30',
                    'AirFit F30i',
                    'AirFit F20',
                    'AirFit F10',
                    'AirFit P30i',
                    'AirFit P10',
                    'AirFit P10 for AirMini',
                    'AirFit N30',
                    'AirFit N30i',
                    'AirFit N20',
                    'AirFit N10',
                    'Mirage Quattro',
                    'Swift FX',
                    'Quattro Air',
                    'Other Full Face',
                    'Other Nasal',
                    'Other Pillows'
                  ],
                  'Fisher & Paykel': [
                    'Simplus',
                    'Pilairo Q',
                    'Opus 360',
                    'Forma',
                    'FlexiFit 431',
                    'Eson',
                    'Eson 2',
                    'Brevida',
                    'Other Full Face',
                    'Other Nasal',
                    'Other Pillows'
                  ],
                  'Philips Respironics': [
                    'Amara',
                    'Amara Gel',
                    'Amara View',
                    'ComfortGel',
                    'ComfortGel Blue',
                    'DreamWear',
                    'Nuance',
                    'Nuance Pro',
                    'Pico',
                    'Wisp',
                    'Other Full Face',
                    'Other Nasal',
                    'Other Pillows'
                  ]
                }
            }
        },
        mixins: [ mixin ],
        methods: {
          updateView(e) {
            this.validation.notPurchasedReason = null
            this.validation.maskModel = null
            if (e.target.options[e.target.options.selectedIndex]) {
                let step = e.target.options[e.target.options.selectedIndex].dataset.nextstep
                this.status.step = step ? step : [];
                let journeyPhase = e.target.options[e.target.options.selectedIndex].dataset.journeyphase;
                switch (journeyPhase) {
                  case '1':
                    this.fields.consumerJourneyPhase = 'Pre-therapy Start';
                    this.fields.consumerJourneyPhaseDetail = 'Seeking Care';
                    break;
                  case '2': case '3':
                    this.fields.consumerJourneyPhase = 'Pre-therapy Start';
                    this.fields.consumerJourneyPhaseDetail = 'Diagnosed';
                    break;
                  default:
                    this.fields.consumerJourneyPhase = '';
                    this.fields.consumerJourneyPhaseDetail = '';
                    break;
                }
            }
          },
          updateOtherMaskBrand(e){
            this.fields.otherMaskModels = '';
            this.updateView(e);
          }
        }
    }
</script>
